/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PrescriptionReportAliases {
  FINAL_DATE_DATE_FIELD = 'final-date-date-field',
  FINAL_DATE_FIELD = 'final-date-field',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INITIAL_DATE_DATE_FIELD = 'initial-date-date-field',
  INITIAL_DATE_FIELD = 'initial-date-field',
  LOADER_0 = 'loader-0',
  MEDIA_CONTAINER = 'media-container',
  PANEL_LOADER = 'panel-loader',
  PRESCRIPTION_REPORT_CONTEXTUAL_BAR = 'prescription-report-contextual-bar',
  PRESCRIPTION_REPORT_FILTER = 'prescription-report-filter',
  PRESCRIPTION_REPORT_LAYOUT = 'prescription-report-layout',
  PRESCRIPTION_REPORT_PANEL_NO_RESULT = 'prescription-report-panel-no-result',
  PRESCRIPTION_REPORT_PANEL_PDF = 'prescription-report-panel-pdf',
  PRESCRIPTION_REPORT_PDF_VIEWER = 'prescription-report-pdf-viewer',
  PRESCRIPTION_REPORT_TEXT = 'prescription-report-text',
}
export { PrescriptionReportAliases };
